<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actual Mileage Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this view shows calculated actual miles for each vehicle & booking by date vs. Telematics daily totals.  select a row for more details</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 20px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data(false)" :disabled="loading">Get Results</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data(true)" :disabled="loading">Rerun Report</b-button>
    </div>

    <div v-if="!loading">
      <div style="font-size: 22px; font-weight: bold; position: relative;">
        <div v-if="summary.total_cnt" class="col" style="float:left; max-width:200px; border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div style="float:right;">
          <span class="d-flex align-items-center justify-content-center">
            Filter&nbsp;<b-form-input style="width: 250px" v-model="vehicle_filter" placeholder="charterID,vehicle,driver"/>
            &nbsp;&nbsp;&nbsp;Mileage Diff&nbsp;&nbsp;<b-form-select v-model="duration_threshold" :options="duration_threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
          </span>
        </div>
      </div>
    </div>
    <br/><br/><br/>


    <div v-if="!loading">
      <table width="100%" border='1' cellpadding='0' cellspacing="0">
        <tr>
          <th colspan="5" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
          <th colspan="9" style="background-color: #C6C6C6">Calulated Booking & Driver Actuals</th>
          <th colspan="3" style="background-color: #D5D5D5">Telematics Daily Trips Totals</th>
          <th colspan="1" style="background-color: #A5A5A5">&nbsp;</th>
        </tr>
        <tr>
          <th width="80px" @click="sort_strings('vehicle')">Vehicle &#8597;</th>
          <th width="90px" @click="sort_numbers('charterIDs')">BookingID &#8597;</th>
          <th width="90px" @click="sort_numbers('assignmentIDs')">AssignmentID &#8597;</th>
          <th width="80px" @click="sort_strings('drivers')">Driver &#8597;</th>
          <th width="80px" @click="sort_strings('is_multiday')">Is Multiday &#8597;</th>
          <th width="100px" @click="sort_dates('actualClockInTime')">Driver Start &#8597;</th>
          <th width="100px" @click="sort_dates('actualStartLocationTime')">Vehicle Start &#8597;</th>
          <th width="100px" @click="sort_dates('actualStartTripTime')">Trip Start &#8597;</th>
          <th width="100px" @click="sort_dates('actualFinishTripTime')">Trip Finish &#8597;</th>
          <th width="100px" @click="sort_dates('actualFinishLocationTime')">Vehicle Finish &#8597;</th>
          <th width="100px" @click="sort_dates('actualClockOutTime')">Driver Finish &#8597;</th>
          <th width="100px" @click="sort_dates('actualStartOdometer')">Start Odometer &#8597;</th>
          <th width="100px" @click="sort_dates('actualEndOdometer')">End Odometer &#8597;</th>
          <th width="100px" @click="sort_dates('actualTotalDistance')">Total Mileage &#8597;</th>
          <th width="100px" @click="sort_dates('samsaraStartOdometer')">Start Odometer&#8597;</th>
          <th width="100px" @click="sort_dates('samsaraEndOdometer')">End Odometer &#8597;</th>
          <th width="100px" @click="sort_dates('samsaraTotalDistance')">Total Mileage &#8597;</th>
          <th width="100px" @click="sort_dates('diffTotalDistance')">Mileage Diff &#8597;</th>
        </tr>
        <template v-for="(item, row_num) in items">
          <tr @click="toggle_div(item,'isMvmtsVisible')">
            <td>{{ item.vehicle | trim(12)}}</td>
            <td>
              <span v-if="item.charterIDs && item.charterIDs.includes(',')">+{{item.charterIDs.split(',')[0]}}</span>
              <span v-else>{{item.charterIDs}}</span>
            </td>
            <td>
              <span v-if="item.assignmentIDs && item.charterIDs.includes(',')">+{{item.assignmentIDs.split(',')[0]}}</span>
              <span v-else>{{item.assignmentIDs}}</span>
            </td>
            <td>{{ item.drivers | trim(20)}} <span v-if="item.driver_hos_link"><a target="_blank" :href="item.driver_hos_link"><img style="margin: 0px 5px 5px 5px" src="/driver-icon.png"/></a></span></td>
            <td>{{ item.is_multiday}}</td>
            <td>{{item.actualClockInTime | formatDateTimeSmall}}</td>
            <td>{{item.actualStartLocationTime | formatDateTimeSmall}}</td>
            <td>{{item.actualStartTripTime | formatDateTimeSmall}}</td>
            <td>{{item.actualFinishTripTime | formatDateTimeSmall}}</td>
            <td>{{item.actualFinishLocationTime | formatDateTimeSmall}}</td>
            <td>{{item.actualClockOutTime | formatDateTimeSmall}}</td>
            <td>{{item.actualStartOdometer}}</td>
            <td>{{item.actualEndOdometer}}</td>
            <td>{{item.actualTotalDistance}}</td>
            <td>{{item.samsaraStartOdometer}}</td>
            <td>{{item.samsaraEndOdometer}}</td>
            <td>{{item.samsaraTotalDistance}}</td>
            <td>{{item.diffTotalDistance}}</td>
          </tr>
          <tr style="background-color: hsla(120,100%,75%,0.3) !important" v-if="item.isMvmtsVisible" v-for="assignment in item.assignments">
            <td colspan="1">&nbsp;</td>
            <td>{{ assignment.charterID }}</td>
            <td>{{ assignment.assignmentID }}</td>
            <td>{{ assignment.driver }}</td>
            <td>{{ assignment.is_multiday}}</td>
            <td>{{ assignment.actualClockInTime | formatDateTimeSmall }}</td>
            <td>{{ assignment.actualStartLocationTime | formatDateTimeSmall }}</td>
            <td>{{ assignment.actualStartTripTime | formatDateTimeSmall }}</td>
            <td>{{ assignment.actualFinishTripTime | formatDateTimeSmall }}</td>
            <td>{{ assignment.actualFinishLocationTime | formatDateTimeSmall }}</td>
            <td>{{ assignment.actualClockOutTime | formatDateTimeSmall }}</td>
            <td>{{ assignment.actualStartOdometer }}</td>
            <td>{{ assignment.actualEndOdometer }}</td>
            <td>{{ assignment.actualTotalDistance }}</td>
            <td colspan="4">&nbsp;</td>
          </tr>
        </template>
        <tr style="font-weight: bold" v-if="summary">
          <td colspan="13"></td>
          <td>{{ summary.totalBookingMiles }}</td>
          <td colspan="2"></td>
          <td>{{ summary.totalSamsaraMiles }}</td>
          <td>{{ summary.totalDiffMiles }}</td>
        </tr>
      </table>
    </div>
    <div v-else-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import {get_tbn_actuals_mileage_report} from "../networking/tbn_apis";

export default {
  name: 'actuals_mileage_tbn',

  components: {
  },

  data() {
    return {
      items: [],
      items_full: [],
      summary: [],
      loading: false,
      vehicle_filter: null,
      selected_vehicle_type: null,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      vehicle_type_options: [],
      duration_threshold: null,
      duration_threshold_options: [
        { value: null, text: 'All' },
        { value: '10', text: '> 10m' },
        { value: '15', text: '> 15m' },
        { value: '30', text: '> 30m' },
        { value: '45', text: '> 45m' },
        { value: '60', text: '> 1h' },
        { value: '120', text: '> 2h' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment(),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {

    },
    async load_data(reprocess) {
      this.loading = true
      this.selected_vehicle_type =''
      this.sort_col = 'vehicle'

      const { value: { data = [] }} = await get_tbn_actuals_mileage_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),reprocess)
      this.summary = data.summary
      moment.tz.setDefault(this.summary.timezone)
      this.items = data.results
      this.items_full = data.results
      this.vehicle_type_options = data.summary.vehicle_types
      this.filter_items()
      this.loading = false
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_vehicle_type != '')
        this.items = this.items.filter(item => item.vehicle_type == this.selected_vehicle_type)
      if (this.vehicle_filter) {
        this.items = this.items.filter(item => (this.contains(item.charterIDs,this.vehicle_filter) || (this.contains(item.assignmentIDs,this.vehicle_filter) || this.contains(item.drivers,this.vehicle_filter) || this.contains(item.vehicle,this.vehicle_filter))))
      }
      if (this.duration_threshold)
        this.items = this.items.filter(item => (Math.abs(item.diffTotalDistance) > this.duration_threshold))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {

            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_vehicle_type(val) {
      this.filter_items()
    },
    duration_threshold() {
      this.filter_items()
    },
    vehicle_filter() {
      this.filter_items()
    }
  }
}
</script>
<style scoped>

.arrows {font-size: 22px; font-weight: bold; color: steelblue !important }
a {color: darkred}

th {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border: 1px solid black;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

</style>


